<template>
	<div class="full-layer-outer-header">
		<div class="container clearfix">
			<nav class="left-section">
				<ul class="primary-nav g-nav">
					<li>
						<a>
							{{ selectedWarehouse ? selectedWarehouse : "Select Warehouse"
							}}<i class="fas fa-home u-s-m-l-9"></i>
						</a>
						<ul class="g-dropdown">
							<li
								v-for="(warehouse, index) in warehouses"
								:key="index"
								style="width: max-content"
								:class="{active: selectedWarehouse == warehouse.name}"
							>
								<a href="#" class="u-c-brand" @click="onChangeWarehouse(warehouse)">
									<i class="fas fa-home u-s-m-r-9"></i>{{ warehouse.name }}</a
								>
							</li>
						</ul>
					</li>
				</ul>
			</nav>
			<nav class="right-section">
				<ul class="secondary-nav g-nav">
					<li>
						<a
							>My Account
							<i class="fas fa-chevron-down u-s-m-l-9"></i>
						</a>

						<ul class="g-dropdown" style="width: 200px" v-if="isLoggedIn">
							<li>
								<router-link :to="{name: 'Profile'}">
									<i class="fas fa-user u-s-m-r-9"></i> Profile
								</router-link>
							</li>
							<li>
								<router-link :to="{name: 'Cart'}">
									<i class="fas fa-cart-arrow-down u-s-m-r-9"></i> My Cart</router-link
								>
							</li>
							<li>
								<router-link :to="{name: 'Orders'}">
									<i class="fas fa-cog u-s-m-r-9"></i> My Orders</router-link
								>
							</li>
							<li>
								<a @click="handlelogout">
									<i class="fas fa-sign-out-alt u-s-m-r-9"></i> Logout
								</a>
							</li>
						</ul>

						<ul class="g-dropdown" style="width: 200px" v-else>
							<li>
								<router-link :to="{name: 'Auth'}">
									<i class="fas fa-sign-in-alt u-s-m-r-9"></i> Login / Signup</router-link
								>
							</li>
						</ul>
					</li>
					<li></li>
				</ul>
			</nav>
		</div>
	</div>
	<LocationModal :current_address="{formatted_address, LatLng}" />
	<Banner v-if="showBanner == 'true'" />

</template>

<script>
	import axios from "axios";
	import {mapActions, mapGetters} from "vuex";
	import LocationModal from "./LocationModal.vue";
	import Banner from "./Banner.vue"
	export default {
		components: {LocationModal, Banner}, //using a new component LocationModal (I need to make it reusable component.)
		data() {
			return {
				LatLng: {lat: "", lng: ""},
				loading: false,
				formatted_address: "",
				warehouses: [
					{name: "iSwitch", lat: "28.5270978", lng: "77.3922024"},
					{name: "Mass Tamilian", lat: "10.0146201", lng: "77.4823095"},
					{name: "Bluejay Automations", lat: "12.946552", lng: "80.2500165"},
					{name: "Wozart", lat: "17.4486151", lng: "78.3632243"}
				],
				selectedWarehouse: "", //selected warehouse
				showBanner: process.env.VUE_APP_SHOW_BANNER,
			};
		},
		computed: {...mapGetters("auth", ["user", "isLoggedIn"])},
		methods: {
			...mapActions("auth", ["logout"]),
			handlelogout() {
				this.logout();
			},
			onChangeWarehouse(warehouse) {
				// when user clicks on a warehouse, it will be selected.
				this.selectedWarehouse = warehouse.name;
				// settting warehouse lat and lng to the local storage.
				localStorage.setItem(
					"location",
					JSON.stringify({lat: warehouse.lat, lng: warehouse.lng})
				);
				//reloading the page.
				window.location.reload();
			},
			//form lat and lng we are getting array of result
			getAddressFrom(lat, lng) {
				return new Promise(async (resolve, reject) => {
					try {
						const res = await axios.get(
							"https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
								lat +
								"," +
								lng +
								"&key=AIzaSyA9Az_2wI5BBoLGDkkC8xXxO3b0pVtsGuU"
						);
						return resolve(res.data.results);
					} catch (error) {
						return reject(error);
					}
				});
			},
		},
		mounted() {
			console.log(this.showBanner)
			//getting location from local storage
			//then for lat and lng we need to get formatted address.
			this.loading = true;
			let location = localStorage.getItem("location");
			this.LatLng = JSON.parse(location);
			let existLocation = this.warehouses.find((warehouse) => {
				return warehouse.lat == this.LatLng.lat && warehouse.lng == this.LatLng.lng;
			});
			if (existLocation) {
				this.selectedWarehouse = existLocation.name;
			}
			this.getAddressFrom(this.LatLng.lat, this.LatLng.lng)
				.then((res) => {
					this.formatted_address = res[0].formatted_address;
					this.loading = false;
				})
				.catch((error) => {
					console.log(error.response.data);
					this.loading = false;
				});
		},
	};
</script>

<style scoped>
	.fa-times {
		cursor: pointer;
	}
	/* .primary-nav {
	  float: left !important;
	}
	.right-section{
		position: relative;
		float: left;
	}
	.right-section{
		position: relative;
		float: right;
	} */
</style>
